module.exports = __webpack_public_path__ + "static/media/3ankab.ae4036d3.png";